var MpPageBusinessDetail;


(function() {
    if (!document.querySelector('#vue-body-business-detail')) {
        return;
    }

    MpPageBusinessDetail = new Vue({
        el: '#vue-body-business-detail',
        mixins: [MpVideoModal],
        data: {
            CONTACT_COUNTER_URL: '/business/incrementContactAttemps',

            // This props comes from BusinessController PHP
            BUSINESS_ID: businessId,
            BUSINESS_TYPE: businessType,
            OWNER_STATUS: ownerStatus,
            GOOGLE_LATITUDE: google_latitude,
            GOOGLE_LONGITUDE: google_longitude,
            GOOGLE_ZOOM: google_zoom,
            MARKER_ICON_CURRENT: google_marker,
            MARKER_ICON_OTHERS: '/img/business/other_business_map_ico.png',
            INSTALLATIONS_IN_RATIO: installations_in_ratio,

            tabsCarousel: null,

            isMapShown: false,
            isContactShown: false,
            isInitialized: false,
        },
        computed: {

            highlightedInstallation: function() {
                return [new MapPoint({
                    lat: this.GOOGLE_LATITUDE,
                    lng: this.GOOGLE_LONGITUDE,
                    icon: this.MARKER_ICON_CURRENT,
                })];
            },

            installationsAround: function() {
                var i,
                    pointTmp,
                    installations = JSON.parse(this.INSTALLATIONS_IN_RATIO),
                    pointList = [];

                pointList.push(new MapPoint({
                    lat: this.GOOGLE_LATITUDE,
                    lng: this.GOOGLE_LONGITUDE,
                    icon: this.MARKER_ICON_CURRENT,
                }));

                for (i=0; i<installations.length; i++) {
                    pointTmp = installations[i];

                    // Mapeamos el formato actual al formato genérico de MapPoint
                    pointList.push(new MapPoint({
                        lat: pointTmp.googleLatitude,
                        lng: pointTmp.googleLongitude,
                        name: pointTmp.name,
                        address: pointTmp.address,
                        zipcode: pointTmp.zipCode,
                        location: pointTmp.location.name,
                        province: pointTmp.province.name,
                        zone: pointTmp.zone.name,
                        phone: pointTmp.phone,
                        icon: this.MARKER_ICON_OTHERS,
                    }));
                }

                return pointList;
            },
        },
        methods: {

            showSlide: function(ev) {
                if (!ev.target.matches('.js-pagination-link')) return;

                ev.preventDefault();
                this.tabsCarousel.slideTo(ev.target.getAttribute('data-index'));
            },

            onSlideChange: function() {
                var swiperChipActive,
                    swiperChips,
                    selectedClass = 'post-detail__tabs-carousel-pagination-link--active';

                swiperChipActive = document.getElementsByClassName(selectedClass);
                swiperChipActive[0].classList.remove(selectedClass);

                swiperChips = document.getElementsByClassName('js-pagination-link');
                swiperChips[this.tabsCarousel.realIndex].classList.add(selectedClass);
            },

            initSwiper: function() {

                this.tabsCarousel = new Swiper(this.$refs.carousel, {
                    autoHeight: true,
                    allowTouchMove: false,
                    simulateTouch: false,
                    on: {
                        init: function() {
                            var swiperChips = document.getElementsByClassName('js-pagination-link');
                            swiperChips[this.realIndex].classList.add('post-detail__tabs-carousel-pagination-link--active');
                        },
                    },
                });

                this.tabsCarousel.on('slideChange', this.onSlideChange);
            },

            closeMapModal: function() {
                noScroll.off();
                this.isMapShown = false;
            },

            showMap: function() {
                noScroll.on();
                this.isMapShown = true;
            },

            showContactInfo: function() {
                this.isContactShown = true;

                axios.post(this.CONTACT_COUNTER_URL, Serializer.serialize({
                    businessId: this.BUSINESS_ID,
                    businessType: this.BUSINESS_TYPE,
                    ownerStatus: this.OWNER_STATUS
                }));
            },

            init: function() {
                if (this.isInitialized) {
                    return;
                }

                this.isInitialized = true;

                if (this.$refs.carousel) {
                    this.initSwiper();
                }
            },
        },

        mounted: function() {
            this.init();
        },

        updated: function() {
            if (!this.isInitialized) {
                this.init();
            }
        },

        destroy: function() {
        }
    });

})();